import bancontact from './bancontact.png'
import ideal from './ideal.png'
import klarna from './klarna.png'
import maestro from './maestro.png'
import mastercard from './mastercard.png'
import paypal from './paypal.png'
import visa from './visa.png'

export const paymentLogos = [
  { alt: 'iDEAL Online betalen', asset: ideal },
  { alt: 'MasterCard', asset: mastercard },
  { alt: 'Maestro', asset: maestro },
  { alt: 'Visa World Card', asset: visa },
  { alt: 'PayPal', asset: paypal },
  { alt: 'Bancontact', asset: bancontact },
  { alt: 'Klarna', asset: klarna },
]
